import styled from "react-emotion"

export const TopBar = styled("div")`
    background-color: ${props => props.theme.surfaceColor};
    height: 30px;
    width: calc(100vw - 30px - 240px);
    border: 1px solid #454648;
    border-bottom: 0;
    border-top: 0;
}
`
TopBar.displayName = "TopBar"

export const BottomBar = styled(TopBar)`
    background-color: #ddd;
`
BottomBar.displayName = "BottomBar"

// background-color: #2a313b;

export const LeftBar = styled("div")`
    background-color: ${props => props.theme.surfaceColor};
    width: 30px;
    flex-basis: 100vh;
`
LeftBar.displayName = "LeftBar"

export const RightBar = styled("div")`
    background-color: ${props => props.theme.surfaceColor};
    width: 240px;
    flex-basis: 100vh;
    max-height: 100vh;
`

RightBar.displayName = "RightBar"

export const PageContentArea = styled("div")`
    background-color: #ccc;
    flex-grow: 1;
    box-shadow: inset 0 0 3px #000000;
    overflow-y: scroll;
    height: calc(100vh - 60px);
    width: 100%;
    max-width: ${props => (props.editing ? "calc(100vw - 30px - 240px)" : "100%")};
    -webkit-overflow-scrolling: touch;

    ${props => props.isFormatPainting && `cursor: copy`};
`

PageContentArea.displayName = "PageContentArea"

export const Frame = styled("div")`
    display: flex;
    height: 100vh;
    width: 100vw;
    flex-direction: column;
    flex-wrap: wrap;
`

Frame.displayName = "Frame"



// WEBPACK FOOTER //
// ./src/features/editor/ui/Frame.js